import { SmartTable } from '../../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
        if (!this.accounts.length) {
            this.$state.go('^', {}, {location: 'replace'})
        }

        this.st = new SmartTable();
        this.export = {
            template: 'groupsusers',
            name: `${this.currentCompany.companyName}-all-users`,
            fields: ['username', 'user', 'accountType', 'status'],
        };
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/all-accounts/export/export-accounts.controller.js